/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Select_Inverse_ButtonInputs */



/**
* | output |
* | --- |
* | "Select Inverse" |
*
* @param {Paste_Attributes_Select_Inverse_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_select_inverse_button = /** @type {((inputs?: Paste_Attributes_Select_Inverse_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Select_Inverse_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inverser la selection")
	if (locale === "de") return /** @type {LocalizedString} */ ("Invertieren auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona Inverso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите обратную операцию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar Inverso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择反向")
	if (locale === "ja") return /** @type {LocalizedString} */ ("逆を選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इनवर्स का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione Inverso")
	return /** @type {LocalizedString} */ ("Select Inverse")
});